import { toClassName } from 'helpers/format';

const text = '';
const paragraph = 'pb-2 sm:pb-4 text-md sm:text-base';
const heading = 'font-medium mb-4 mt-5';
const link = 'text-red-500 underline !z-50';

const styles = {
  block: {
    paragraph: toClassName(text, paragraph),
    h1: toClassName(text, heading, 'sm:text-3xl'),
    h2: toClassName(text, heading, 'sm:text-2xl'),
    h3: toClassName(text, heading, 'sm:text-xl'),
    h4: toClassName(text, heading, 'sm:text-lg'),
    h5: toClassName(text, heading, 'sm:text-md'),
    h6: toClassName(text, heading, 'sm:text-base'),
    list: '',
    quote: '',
    code: '',
    image: '',
    link: toClassName(text, paragraph, link),
  },

  modifier: {
    bold: '',
    italic: '',
    underline: '',
    strikethrough: '',
    code: '',
  },
};

export default styles;
